<template>
  <router-view />
</template>

<script>
export default {
  name: 'HotelManagementIndex'
}
</script>
